import React from 'react';
import buildResourcePath from '@lib/buildResourcePath';

//TODO: APLICATION VERSION!!!!!!!!!!!!

const DesktopNavigation = class DesktopNavigation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="navigation-bar-left-side main-navigation-bar">
                <a href={buildResourcePath('/')} class="navigation-bar-logo">
                    {this.props.isDalkia ? <img src="~/assets/dalkia-logo.png"/> :
                        <img src="~/assets/cetetherm-logo.png"/>}
                </a>

                <a class="navigation-bar-item">
                    <img class="navigation-bar-item-icon" src="~/assets/icons/icon_web_select.svg"/>
                    <span class="navigation-bar-item-label">{__('WebSelect')}</span>
                    <span class="navigation-bar-item-caret"></span>
                </a>

                <a class="navigation-bar-item">
                    <img class="navigation-bar-item-icon" src="~/assets/icons/icon_web_select.svg" />
                    <span class="navigation-bar-item-label">{__('Tap water system')}</span>
                    <span class="navigation-bar-item-caret"></span>
                </a>

                {this.props.sparePartsFinderAccess && (
                    <a class="navigation-bar-item" href={buildResourcePath('/SparePartsFinder/Index')}>
                        <img class="navigation-bar-item-icon" src="~/assets/icons/icon_spare_parts_finder.svg"/>
                        <span class="navigation-bar-item-label">{__('Spare Parts Finder')}</span>
                    </a>)}

                {this.props.mediaBankAccess && (
                    <a class="navigation-bar-item attr--disabled">
                        <img class="navigation-bar-item-icon" src="~/assets/icons/icon_media_bank.svg"/>
                        <span class="navigation-bar-item-label">{__('Media Bank')}</span>
                    </a>)}
            </div>
        )
    }
}

window.components.DesktopNavigation = DesktopNavigation;